import React, { Component } from 'react'
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import { connect } from 'react-redux'
import serializeForm from 'form-serialize'
import arrow_right_img from '../../utils/assets/images/arrow-right.png'
import calendar_img from '../../utils/assets/images/calendar.png'
import fi_alert_img from '../../utils/assets/images/fi-alert.png'
import { Link } from 'react-router-dom'
import moment from 'moment'
import logo_abc from '../../utils/assets/images/AAB_V2.jpg'
//import dateIconBlack from '../../utils/assets/images/date_icon_black.PNG'
import { fetchDownloadDevisLogoCourtierAction } from '../../actions/Simulation/Devis'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import UIkit from 'uikit'
import './Simulation.css'
import { getRecap } from '../../utils/helpers/recapBudgetSimulation'
import axios from 'axios'
import './Simulation-Modal-mobile.css'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from "react-datepicker"
import barnersSimulation from '../../utils/assets/images/barners_particuliers.jpg'
import barnersSimulationMobile from '../../utils/assets/images/barners_particuliers_mobile.jpg'
import { SERVER_URL } from '../../utils/helpers/constanteData'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchSendMailSouscripteurAction } from '../../actions/Souscription/Souscripteur'

class Simulation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      invalidFormNextUn: true,
      invalidFormNextDeux: true,
      invalidFormNextTrois: true,
      currentPage: 1,
      invalidBetweenDateInsuredBirthDate: false,
      invalidBetweenDateBirthSpouse: false,
      startSouscriptionDay: null,
      primaryInsuredBirthDate: null,
      dateBirthSpouse: null,
      allchildBeneficiaires: [],
      notificationSendMailToSimulationError: false,
      notificationConversionDevisError: false,
      isLoadingConvert: false,
      notificationSuccessConversionPDF: false,
      nbrChildAssurance: 0,
      nbrChildConjoint: 0,
      nbrChildAssuranceLead: 0,
      isMedicalBills: false,
      isIndividuelAccident: false,
      isCheckedPremier: false,
      isCheckedVitalite: false,
      isCheckedPrestige: false,
      isCheckedPlan: false,
      isSelectAssuranceLead: false,
      isSelectAssuranceConjoint: false,
      dataNbrChildAssurance: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      dataNbrChildAssuranceLead: {"0": "Choisir", "3500000": "3 500 000", "5250000": "5 250 000", "7000000": "7 000 000"},
      dataNbrChildConjoint: {"0": "Choisir", "3500000": "3 500 000", "5250000": "5 250 000", "7000000": "7 000 000"},
      NbrChildCorrespondances: {
        0: 0,
        3500000: 10000,
        5250000: 15000,
        7000000: 20000,
      },
      nbrChildConjointPrime: 0,
      nbrChildAssuranceLeadPrime: 0,
      nbrChildTotalPrime: 0,
    }
    
    this.handleChangeDatePickerSouscriptionDay = this.handleChangeDatePickerSouscriptionDay.bind(this)
    this.handleChangeprimaryInsuredBirthDate = this.handleChangeprimaryInsuredBirthDate.bind(this)
    this.handleChangedateBirthSpouse = this.handleChangedateBirthSpouse.bind(this)
    this.handleChangeAllchildBeneficiaires = this.handleChangeAllchildBeneficiaires.bind(this)
  }
  componentDidMount() {
    document.title = `Simulation tarifaire`

    const { reauthenticateMembers, getReauthenticate, userDownloadDevisLogoCourtier } = this.props

    if (Object.keys(reauthenticateMembers.userData).length === 0) {
      getReauthenticate()
    }
    let codeApporteur = JSON.parse(localStorage.getItem('ApsBeninParentCodeStorage'))

    userDownloadDevisLogoCourtier(codeApporteur)
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.sendMailToSouscripteur.isError !== this.props.sendMailToSouscripteur.isError) {
      this.setState({ notificationSendMailToSimulationError: nextProps.sendMailToSouscripteur.isError })
    }
    if (nextProps.notificationConversionDevisError !== this.props.notificationConversionDevisError) {
      this.setState({ notificationConversionDevisError: nextProps.notificationConversionDevisError })
    }
    if (nextState.isCheckedPlan !== this.state.isCheckedPlan) {
      if(nextState.isCheckedPlan) {
        this.setState({ invalidFormNextTrois: false })
      }
    }
    if (nextState.nbrChildAssurance !== this.state.nbrChildAssurance) {
      let allchildBeneficiaires = []
      let oldAllchildBeneficiaires = [...this.state.allchildBeneficiaires]

      for (let i = 0; i < nextState.nbrChildAssurance; i++) { 
        if(oldAllchildBeneficiaires[i] && Object.keys(oldAllchildBeneficiaires[i]).length !== 0) {
          allchildBeneficiaires.push({date: oldAllchildBeneficiaires[i].date, invalidDate: oldAllchildBeneficiaires[i].invalidDate})
        }else {
          allchildBeneficiaires.push({date: null, invalidDate: true})
        }
      }
      this.setState({allchildBeneficiaires, invalidFormNextDeux: true})
    }
  }
  handleChangeDatePickerSouscriptionDay(date) {
    if(date) {
      this.setState({ startSouscriptionDay: date, invalidFormNextUn: false })
    }else {
      this.setState({ startSouscriptionDay: date, invalidFormNextUn: true })
    }
  }
  handleChangeprimaryInsuredBirthDate(date) {
    if(date && !isYounger(date, 18) && !isOlder(date, 65)) {
      this.setState({ primaryInsuredBirthDate: date, invalidFormNextDeux: false, invalidBetweenDateInsuredBirthDate: false })
    }else {
      this.setState({ primaryInsuredBirthDate: date, invalidFormNextDeux: true, invalidBetweenDateInsuredBirthDate: true })
    }
  }
  handleChangedateBirthSpouse(date) {
    if(date && !isYounger(date, 18) && !isOlder(date, 65)) {
      this.setState({ dateBirthSpouse: date, invalidFormNextDeux: false, invalidBetweenDateBirthSpouse: false })
    }else {
      this.setState({ dateBirthSpouse: date, invalidFormNextDeux: true, invalidBetweenDateBirthSpouse: true })
    }
  }
  handleChangeAllchildBeneficiaires(crrData, position) {
    this.setState(
      (prevState, props) => {
        let checkInvalidDate = true
        let verifyInvalidDate = 0
        let data = prevState.allchildBeneficiaires
        data[position] = crrData

        for (let i = 0; i < data.length; i++) {
          if(!data[i].invalidDate) {
            verifyInvalidDate++
          }
        }
        if(verifyInvalidDate === data.length) {
          checkInvalidDate = false
        }

      return { allchildBeneficiaires: data, invalidFormNextDeux: checkInvalidDate }
    })
  }
  handleOnNbrChildAssurance = (event) => {
    event.preventDefault()
    let value = event.target.value
    this.setState({ nbrChildAssurance: value })
  }
  handleOnNbrChildAssuranceLead = (event) => {
    event.preventDefault()
    let value = event.target.value
    this.setState(
      (prevState, props) => {
      let data = prevState.NbrChildCorrespondances
      let total = data[value] + prevState.nbrChildConjointPrime

      return { nbrChildAssuranceLead: value, nbrChildAssuranceLeadPrime: data[value], nbrChildTotalPrime: total }
    })
  }
  handleOnNbrChildConjoint = (event) => {
    event.preventDefault()
    let value = event.target.value
    this.setState(
      (prevState, props) => {
      let data = prevState.NbrChildCorrespondances
      let total = data[value] + prevState.nbrChildAssuranceLeadPrime

      return { nbrChildConjoint: value, nbrChildConjointPrime: data[value], nbrChildTotalPrime: total }
    })
  }
  getEndDate = (date) => {
    return date ? moment(date).add(1, 'y').subtract(1, 'd') : null
  }
  checkCloseCanvas = () => {
    UIkit.offcanvas.hide('#aps-simulation-login-modal-center')
  }
  handleMedicalBillsCheckboxChange = (event) => {
    this.setState({isMedicalBills: event.target.checked})
  }
  handleIndividuelAccidentCheckboxChange = (event) => {
    this.setState({isIndividuelAccident: event.target.checked})
  }
  handleSelectAssuranceLeadCheckboxChange = (event) => {
    this.setState({isSelectAssuranceLead: event.target.checked})
  }
  handleSelectAssuranceConjointCheckboxChange = (event) => {
    this.setState({isSelectAssuranceConjoint: event.target.checked})
  }
  handleChangeRemoveBirthSpouse = () => {
    const { primaryInsuredBirthDate, allchildBeneficiaires } = this.state

    if (primaryInsuredBirthDate || allchildBeneficiaires.length !== 0) {
      this.setState({invalidFormNextDeux: false, dateBirthSpouse: null})
    }else {
      this.setState({invalidFormNextDeux: true, dateBirthSpouse: null})
    }
  }
  handleNextPage = event => {
    event.preventDefault()
    let { currentPage } = this.state
    
    this.setState({ currentPage: currentPage + 1 })
  }
  handlePrevPage = event => {
    event.preventDefault()
    let { currentPage } = this.state
    
    this.setState({ currentPage: currentPage - 1 })
  }
  handleSubmit = (event) => {
    event.preventDefault()
    const { userSendMailToSimulation, downloadDevisLogoCourtier } = this.props
    const FormValues = serializeForm(event.target, { hash: true })

    if (Object.keys(FormValues).length !== 0) {
      let newFormValues = serializeJavascript.sanitize(FormValues)
      this.setState({ isLoadingConvert: true })

      let populationAssurance = ""
      if (this.state.primaryInsuredBirthDate) {
        populationAssurance = "assuré principal"
      }
      if (this.state.dateBirthSpouse) {
        populationAssurance = `${populationAssurance} + conjoint`
      }
      if (this.state.nbrChildAssurance) {
        if (this.state.nbrChildAssurance === 1) {
          populationAssurance = `${populationAssurance} + ${this.state.nbrChildAssurance} enfant`
        } else {
          populationAssurance = `${populationAssurance} + ${this.state.nbrChildAssurance} enfants`
        }
      }

      let allBeneficiaires = []

      if (this.state.primaryInsuredBirthDate) {
        allBeneficiaires.push({
          lien: "assurePrincipal",
          birthday: moment(this.state.primaryInsuredBirthDate).format('DD-MMM-YYYY')
        })
      }
      if (this.state.dateBirthSpouse) {
        allBeneficiaires.push({
          lien: "conjoint",
          birthday: moment(this.state.dateBirthSpouse).format('DD-MMM-YYYY')
        })
      }
      if (this.state.allchildBeneficiaires.length !== 0) {
        for (let i = 0; i < this.state.allchildBeneficiaires.length; i++) {
          allBeneficiaires.push({
            lien: "enfant",
            birthday: moment(this.state.allchildBeneficiaires[i].date).format('DD-MMM-YYYY')
          })
        }
      }
      
      let allRecapSys = getRecap(this.state.isCheckedPremier ? "premier" : this.state.isCheckedVitalite ? "vitalite" : this.state.isCheckedPrestige ? "prestige" : "", allBeneficiaires, this.state.nbrChildTotalPrime)

      let simulationData = {
        "civility": newFormValues.civility.charAt(0).toUpperCase() + newFormValues.civility.slice(1).toLowerCase(),
        "first_name": newFormValues.firstname,
        "last_name": newFormValues.lastname,
        "date": moment(new Date()).format('DD MMMM YYYY'),
        "birthDay": this.state.primaryInsuredBirthDate ? moment(this.state.primaryInsuredBirthDate).format('DD MMMM YYYY') : "",
        "souscriptionDate": moment(this.state.startSouscriptionDay).format('DD MMMM YYYY'),
        "email": newFormValues.email,
        "fraisSante": `${allRecapSys.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "territorialite": "BENIN avec une extension sur le reste de l’Afrique et l’Europe",
        "formule": this.state.isCheckedPremier ? "Premier" : this.state.isCheckedVitalite ? "Vitalité" : this.state.isCheckedPrestige ? "Prestige" : "",
        "populationAssurance": populationAssurance,
        "discountFamily": `${allRecapSys.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "cotisationAccident": `${this.state.nbrChildTotalPrime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "fraisAdhesionAnnuel": `${allRecapSys.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "cotisationTTC": `${allRecapSys.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "individuelAccAssure": `${this.state.nbrChildAssuranceLead.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "individuelAccConjoint": `${this.state.nbrChildConjoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA`,
        "valideSOuscriptionDate": `31/12/${new Date().getFullYear()}`
      }

      if (downloadDevisLogoCourtier.isSuccess) {
        if (downloadDevisLogoCourtier.logoCourtier.data.logo.length === 0) {
          simulationData["courtier_logo"] = ''
        }else {
          simulationData["courtier_logo"] = downloadDevisLogoCourtier.logoCourtier.data.logo
        }
        simulationData["courtier_fullname"] = downloadDevisLogoCourtier.logoCourtier.data.companyName
        simulationData["courtier_phone"] = downloadDevisLogoCourtier.logoCourtier.data.telephone
        simulationData["courtier_email"] = downloadDevisLogoCourtier.logoCourtier.data.email
      }else {
        simulationData["courtier_logo"] = ''
        simulationData["courtier_fullname"] = 'ABC'
        simulationData["courtier_phone"] = '+229 60 11 27 27'
        simulationData["courtier_email"] = 'christian@africabrokersonline.com'
      }


      axios.post(SERVER_URL + "/generate/simulation/devis", simulationData)
        .then((urlDownloadDevis) => {
          this.setState({ isLoadingConvert: false, notificationSuccessConversionPDF: true})
          console.log("urlDownloadDevis", urlDownloadDevis)
          //Conversion into PDF success
          if (urlDownloadDevis.status === 200) {
            userSendMailToSimulation({email: `${newFormValues.email}, ${newFormValues.emailFacultatif}, ${simulationData.courtier_email}`,
              subject: newFormValues.firstname + " " + newFormValues.lastname + ", votre devis de simulation",
              type: "after-simulation",
              name: newFormValues.lastname + " " + newFormValues.firstname,
              devisFile: `${SERVER_URL}/downloads/${urlDownloadDevis.data.path_simulation}`,
            })
          }
        })
        .catch((error) => {
          this.setState({ isLoadingConvert: false })
          this.setState({ notificationConversionDevisError: true })
        });
    }
  }
  resetAllFields = () => {
    if (this.state.notificationSuccessConversionPDF) {
      this.setState({notificationSuccessConversionPDF: false})
    }
  }
  NotificationSendMailToSimulationError = () => {
    UIkit.notification({
      message: "<i className='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur lors de l'envoie du mail",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationSendMailToSimulationError: false })
  }
  NotificationConversionDevisError = () => {
    UIkit.notification({
      message: "<i className='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur lors de la conversion du fichier",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationConversionDevisError: false })
  }

  render() {
    const { reauthenticateMembers, sendMailToSouscripteur, downloadDevisLogoCourtier } = this.props
    const { currentPage, startSouscriptionDay, primaryInsuredBirthDate, dateBirthSpouse, notificationSendMailToSimulationError,
      notificationConversionDevisError, isLoadingConvert, notificationSuccessConversionPDF,
      nbrChildAssurance, nbrChildConjoint, nbrChildAssuranceLead, isMedicalBills, isIndividuelAccident, isCheckedPremier, isCheckedVitalite, isCheckedPrestige,
      isCheckedPlan, isSelectAssuranceLead, dataNbrChildAssurance, dataNbrChildAssuranceLead, dataNbrChildConjoint, isSelectAssuranceConjoint,
      nbrChildTotalPrime, invalidFormNextUn, invalidFormNextDeux, invalidFormNextTrois, allchildBeneficiaires, invalidBetweenDateInsuredBirthDate,
      invalidBetweenDateBirthSpouse } = this.state
    
    let allBeneficiaires = []

    if (primaryInsuredBirthDate) {
      allBeneficiaires.push({
        lien: "assurePrincipal",
        birthday: moment(primaryInsuredBirthDate).format('DD-MMM-YYYY')
      })
    }
    if (dateBirthSpouse) {
      allBeneficiaires.push({
        lien: "conjoint",
        birthday: moment(dateBirthSpouse).format('DD-MMM-YYYY')
      })
    }
    if (allchildBeneficiaires.length !== 0) {
      for (let i = 0; i < allchildBeneficiaires.length; i++) {
        allBeneficiaires.push({
          lien: "enfant",
          birthday: moment(allchildBeneficiaires[i].date).format('DD-MMM-YYYY')
        })
      }
    }
    

    let premierRecap = getRecap("premier", allBeneficiaires, nbrChildTotalPrime)
    let vitaliteRecap = getRecap("vitalite", allBeneficiaires, nbrChildTotalPrime)
    let prestigeRecap = getRecap("prestige", allBeneficiaires, nbrChildTotalPrime)
    
    return (
      <div>
        <Header userIsSuccessLogin={reauthenticateMembers.isSuccess} />
          <div>
            {/* Subheader */}
            <div className="uk-container-large aps-container-large">
              <div className="uk-section aps-section-subheader-subtitle">
                <div className="uk-inline-clip aps-subheader-uk-inline">
                  {/* Img on Web */}
                  <img className="aps-subheader-cover-img aps-subheader-cover-img-show-web" 
                  src={barnersSimulation} alt="cover" />
                  {/* Img on Mobile */}
                  <img style={{display: "none"}} className="aps-subheader-cover-img aps-subheader-cover-img-show-mobile" 
                  src={barnersSimulationMobile} alt="cover" />
                  <div className="aps-subheader-cover-img-overlay uk-position-cover"></div>
                  <div className="uk-text-center uk-position-center aps-subheader-overlay-content">
                    <h1 className="aps-subheader-overlay-content-title">
                      Réalisez votre devis en <br />quelques clics !
                    </h1>
                    <p className="aps-subheader-overlay-content-subtitle">
                      Ce devis est immédiat, gratuit, personnalisé et sans engagement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div  className="aps-container-center-bloc aps-simulation-container-components">
              <div className="aps-simulation-switch-wrap" data-uk-grid> 
                <div className="uk-width-1-4 aps-simulation-switch-wrap-item-un">
                  <div className={`aps-simulation-switch-wrap-item-bg ${currentPage === 1 ? 'aps-simulation-switch-wrap-item-bg-completed' : ''}`}>
                    <div className="aps-simulation-switch-menu-tab-item-oval-default">
                      <span className="aps-dashboard-menu-tab-item-oval-number-default">1</span>
                    </div>
                    <span className="aps-simulation-switch-menu-tab-title">L'assurance santé SƆHU</span>
                  </div>
                </div>
                <div className="uk-width-1-4 aps-simulation-switch-wrap-item-deux">
                  <div className={`aps-simulation-switch-wrap-item-bg ${currentPage === 2 ? 'aps-simulation-switch-wrap-item-bg-completed' : ''}`}>
                    <div className="aps-simulation-switch-menu-tab-item-oval-default">
                      <span className="aps-dashboard-menu-tab-item-oval-number-default">2</span>
                    </div>
                    <span className="aps-simulation-switch-menu-tab-title">Les bénéficiaires</span>
                  </div>
                </div>
                <div className="uk-width-1-4 aps-simulation-switch-wrap-item-trois">
                  <div className={`aps-simulation-switch-wrap-item-bg ${currentPage === 3 ? 'aps-simulation-switch-wrap-item-bg-completed' : ''}`}>
                    <div className="aps-simulation-switch-menu-tab-item-oval-default">
                      <span className="aps-dashboard-menu-tab-item-oval-number-default">3</span>
                    </div>
                    <span className="aps-simulation-switch-menu-tab-title">Le choix de couverture</span>
                  </div>
                </div>
                <div className="uk-width-1-4 aps-simulation-switch-wrap-item-quatre">
                  <div className={`aps-simulation-switch-wrap-item-bg ${currentPage === 4 ? 'aps-simulation-switch-wrap-item-bg-completed' : ''}`}>
                    <div className="aps-simulation-switch-menu-tab-item-oval-default">
                      <span className="aps-dashboard-menu-tab-item-oval-number-default">4</span>
                    </div>
                    <span className="aps-simulation-switch-menu-tab-title">Votre devis</span>
                  </div>
                </div>
              </div>
              {currentPage === 1 && (
                <div>
                  <div className="aps-simulation-v2-wrap-section">
                    <div className="aps-simulation-v2-title">
                      Territorialité : 
                      <span className="uk-text-bold"> BENIN avec une extension sur le reste de l’Afrique et l’Europe pour les séjours temporaires</span>
                    </div>
                    <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                      Date d'effet souhaitée :
                    </div>
                    <div data-uk-grid>
                      <div className="uk-width-1-4">
                        <div className="aps-simulation-v2-picto-date-assure-container-icon">
                          <DatePicker
                            className={`uk-input aps-section-register-fields`}
                            dateFormat="DD-MMM-YYYY"
                            name="souscripteurDate"
                            placeholderText="___/___/_____"
                            locale="fr"
                            readOnly
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            minDate={moment().add(1, 'd')}
                            maxDate={moment().add(90, 'd')}
                            showDisabledMonthNavigation
                            selected={startSouscriptionDay}
                            onChange={date => this.handleChangeDatePickerSouscriptionDay(date)}
                          />
                          {/*<img className="aps-simulation-v2-picto-date-assure-item-icon" src={dateIconBlack} alt="aps-benin-icon-date" />*/}
                        </div>
                      </div>
                      <div className="uk-width-expand aps-simulation-v2-picto-date-assure">
                        <i className="fa fa-info-circle aps-simulation-v2-picto-infos" style={{fontSize: "18px"}}></i>
                        <span className="aps-section-alerte-green-content-full uk-text-justify aps-simulation-v2-checkbox-mg-bolder"
                          style={{paddingLeft: "10px", fontSize: "14px"}}>
                          Date à partir de laquelle vous souhaitez être couvert
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                        <button
                          className={`uk-button aps-btn-green aps-btn-green-dashboard-btn ${invalidFormNextUn ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                          onClick={(event) => this.handleNextPage(event)}
                          disabled={invalidFormNextUn}
                        >Section suivante</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentPage === 2 && (
                <div>
                  <div className="aps-simulation-v2-wrap-section">
                    <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                      Date de naissance assuré principal :
                    </div>
                    <div data-uk-grid>
                      <div className="uk-width-1-4">
                        <div className="aps-simulation-v2-picto-date-assure-container-icon">
                          <DatePicker
                            className={`uk-input aps-section-register-fields red-border ${invalidBetweenDateInsuredBirthDate ? 'aps-section-register-fields-required' : ''}`}
                            dateFormat="DD-MMM-YYYY"
                            name="souscripteurDate"
                            placeholderText="___/___/_____"
                            locale="fr"
                            readOnly
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={moment().add(0, 'd')}
                            showDisabledMonthNavigation
                            selected={primaryInsuredBirthDate}
                            onChange={date => this.handleChangeprimaryInsuredBirthDate(date)}
                          />
                          {/*<img className="aps-simulation-v2-picto-date-assure-item-icon" src={dateIconBlack} alt="aps-benin-icon-date" />*/}
                          {primaryInsuredBirthDate && <div className="uk-text-bold aps-simulation-v2-picto-date-assure-item-format">
                            {moment(primaryInsuredBirthDate).format('DD MMMM YYYY')} ({moment().diff(moment(primaryInsuredBirthDate, "DD-MMM-YYYY"), 'years')} ans)
                          </div>}
                          {invalidBetweenDateInsuredBirthDate && (<p style={{marginBottom: "0px"}} className="uk-text-left aps-section-register-fields-required-alert">
                            L'assuré principal doit avoir au moins 18 ans et 65 ans au plus.
                          </p>)} 
                        </div>
                      </div>
                      <div className="uk-width-expand"></div>
                    </div>
                    <div className="aps-simulation-v2-beneficiare-container">
                      <ul className="aps-dashboard-beneficiare-accordion-container" data-uk-accordion>
                        <li className="">
                          <h3 className="uk-accordion-title uk-text-center aps-dashboard-beneficiare-accordion-title">
                            Assurer son conjoint 
                          </h3>
                          <div className="uk-accordion-content aps-dashboard-beneficiare-accordion-content">
                            <div className="answer-souscription-beneficiaire">
                              <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                                Date de naissance du conjoint  :
                              </div>
                              <div data-uk-grid>
                                <div className="uk-width-1-4">
                                  <div className="aps-simulation-v2-picto-date-assure-container-icon">
                                    <DatePicker
                                      className={`uk-input aps-section-register-fields red-border ${invalidBetweenDateBirthSpouse ? 'aps-section-register-fields-required' : ''}`}
                                      dateFormat="DD-MMM-YYYY"
                                      name="souscripteurDate"
                                      placeholderText="___/___/_____"
                                      locale="fr"
                                      readOnly
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      maxDate={moment().add(0, 'd')}
                                      showDisabledMonthNavigation
                                      selected={dateBirthSpouse}
                                      onChange={date => this.handleChangedateBirthSpouse(date)}
                                    />
                                    {/*<img className="aps-simulation-v2-picto-date-assure-item-icon" src={dateIconBlack} alt="aps-benin-icon-date" />*/}
                                    {dateBirthSpouse && <div className="uk-text-bold aps-simulation-v2-picto-date-assure-item-format">
                                      {moment(dateBirthSpouse).format('DD MMMM YYYY')} ({moment().diff(moment(dateBirthSpouse, "DD-MMM-YYYY"), 'years')} ans)
                                    </div>}
                                    {invalidBetweenDateBirthSpouse && (<p style={{marginBottom: "0px"}} className="uk-text-left aps-section-register-fields-required-alert">
                                      Le conjoint doit avoir au moins 18 ans et 65 ans au plus.
                                    </p>)}
                                  </div>
                                </div>
                                <div className="uk-width-expand">
                                  <button className="uk-button aps-btn-silver aps-btn-silver-dashboard-btn"
                                    onClick={() => this.handleChangeRemoveBirthSpouse()}>
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="">
                          <h3 className="uk-accordion-title uk-text-center aps-dashboard-beneficiare-accordion-title">
                            Assurer ses enfants
                          </h3>
                          <div className="uk-accordion-content aps-dashboard-beneficiare-accordion-content">
                            <div className="answer-souscription-beneficiaire">
                              <div className="aps-simulation-v2-answer-assurance">
                                <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                                  Nombre d'enfants à assurer :
                                </div>
                                <select
                                  className="uk-select aps-section-register-fields aps-simulation-v2-number-input"
                                  name="nbrChildAssurance"
                                  value={nbrChildAssurance}
                                  onChange={event => this.handleOnNbrChildAssurance(event)}
                                >
                                  {Object.keys(dataNbrChildAssurance).map((value, i) => {
                                    return (
                                      <option value={value} key={i}>{value}</option>
                                    );
                                  })}
                                </select>
                                {(nbrChildAssurance !== 0) && (
                                  Object.keys(allchildBeneficiaires).map((value, i) => {
                                    return (
                                      <div key={i}>
                                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                                          Date de naissance : enfant <span className="uk-text-bold">{i + 1}</span>
                                        </div>
                                        <div data-uk-grid>
                                          <div className="uk-width-1-3">
                                            <div className="aps-simulation-v2-picto-date-assure-container-icon">
                                              <DatePicker
                                                className={`uk-input aps-section-register-fields red-border ${allchildBeneficiaires[i].invalidDate ? 'aps-section-register-fields-required' : ''}`}
                                                dateFormat="DD-MMM-YYYY"
                                                name="souscripteurDate"
                                                placeholderText="___/___/_____"
                                                locale="fr"
                                                readOnly
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                maxDate={moment().add(0, 'd')}
                                                showDisabledMonthNavigation
                                                selected={allchildBeneficiaires[i].date}
                                                onChange={date => this.handleChangeAllchildBeneficiaires({date, invalidDate: !isYounger(date, 27)}, i)}
                                              />
                                              {allchildBeneficiaires[i].date && <div className="uk-text-bold aps-simulation-v2-picto-date-assure-item-format">
                                                {moment(allchildBeneficiaires[i].date).format('DD MMMM YYYY')} ({moment().diff(moment(allchildBeneficiaires[i].date, "DD-MMM-YYYY"), 'years')} ans)
                                              </div>}
                                              {allchildBeneficiaires[i].invalidDate && (<p style={{marginBottom: "0px"}} className="uk-text-left aps-section-register-fields-required-alert">
                                                L'enfant doit avoir 26 ans au plus.
                                              </p>)}
                                            </div>
                                          </div>
                                          <div className="uk-width-expand"></div>
                                        </div>
                                      </div>
                                    )
                                  })
                                )}
                                <div className="aps-simulation-v2-title-yellow-color">
                                  Un enfant peut être assuré jusqu'à l'âge de 26 ans s'il poursuit des études. Dépassé l'âge limite, il ne pourra être considéré comme un enfant à charge. Veuillez souscrire un contrat individuel pour cet enfant.
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                        <button
                          className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn`}
                          onClick={(event) => this.handlePrevPage(event)}
                        >Section précédente</button>

                        <button
                          className={`uk-button aps-btn-green aps-btn-green-dashboard-btn ${invalidFormNextDeux ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                          onClick={(event) => this.handleNextPage(event)}
                          disabled={invalidFormNextDeux}
                        >Section suivante</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentPage === 3 && (
                <div>
                  <div className="aps-simulation-v2-wrap-section">
                    <div className="aps-questionnaire-answers-checkbox-first-content">
                      <label className="aps-questionnaire-answers-label uk-text-bold">
                        <input checked={isMedicalBills} onChange={this.handleMedicalBillsCheckboxChange} className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                        Frais de santé
                      </label>
                    </div>
                    {isMedicalBills && (
                      <div className="aps-simulation-v2-checkbox-mg">
                        <div className="aps-questionnaire-answers-label uk-text-bold uk-text-center aps-simulation-v2-checkbox-txt-size">
                          Choisissez votre formule de garanties
                        </div>
                        <div className="aps-simulation-v2-answer-assurance aps-simulation-v2-answer-assurance-content">
                          <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={arrow_right_img} alt="arrow-right"/>
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                <div className="uk-width-1-6" style={{width: "14%"}}>PREMIER : </div> 
                                <div className="uk-width-expand" style={{padding: "0"}}>couverture à 60% pour les frais d’hospitalisation et dépenses de médecine courante</div>
                              </div>
                            </div>
                          </div>
                          <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={arrow_right_img} alt="arrow-right"/>
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                <div className="uk-width-1-6" style={{width: "14%"}}>VITALITE : </div> 
                                <div className="uk-width-expand" style={{padding: "0"}}>couverture à 70% pour les frais d’hospitalisation, dépenses de médecine courante, de maternité, frais dentaires et d'optique</div>
                              </div>
                            </div>
                          </div>
                          <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                            <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                              <img src={arrow_right_img} alt="arrow-right"/>
                            </div>
                            <div className="uk-width-expand aps-section-alerte-green-expand">
                              <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                <div className="uk-width-1-6" style={{width: "14%"}}>PRESTIGE : </div> 
                                <div className="uk-width-expand" style={{padding: "0"}}>couverture à 80% pour les frais d’hospitalisation, dépenses de médecine courante, de maternité, frais dentaires et d'optique</div>
                              </div>
                            </div>
                          </div>
                          <div className="aps-simulation-v2-answer-assurance-content-table-price">
                            <table className="uk-table uk-table-small aps-table-simulation-content aps-js-cal-tab-2">
                              <tbody>
                                <tr>
                                  <td className="uk-text-center aps-table-simulation-content-title-top"></td>
                                  <td className={`uk-text-center aps-table-simulation-content-title-top
                                    ${isCheckedPremier ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                  `}>PREMIER</td>
                                  <td className={`uk-text-center aps-table-simulation-content-title-top
                                    ${isCheckedVitalite ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                  `}>VITALITE</td>
                                  <td className={`uk-text-center aps-table-simulation-content-title-top
                                    ${isCheckedPrestige ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                  `}>PRESTIGE</td>
                                </tr>
                                <tr>
                                  <td className="aps-table-simulation-content-divider-top">Cotisation brute :</td>
                                  <td
                                    className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPremier ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {premierRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedVitalite ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {vitaliteRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPrestige ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {prestigeRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="aps-table-simulation-content-divider-top">Réduction famille :</td>
                                  <td
                                    className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPremier ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {premierRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedVitalite ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {vitaliteRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPrestige ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {prestigeRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="aps-table-simulation-content-divider-top">Accessoires :</td>
                                  <td
                                    className="aps-table-simulation-content-divider-top uk-text-center">
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {premierRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className="aps-table-simulation-content-divider-top uk-text-center">
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {vitaliteRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className="aps-table-simulation-content-divider-top uk-text-center">
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {prestigeRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                </tr>
                                <tr className={`uk-text-bold
                                  ${!isCheckedPlan ? 'aps-simulation-v2-table-price-bg-silver' : ''}`}>
                                  <td className="aps-table-simulation-content-divider-top">Cotisation annuelle TTC :</td>
                                  <td
                                    className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPremier ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {premierRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedVitalite ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {vitaliteRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                  <td className={`aps-table-simulation-content-divider-top uk-text-center
                                      ${isCheckedPrestige ? 'aps-simulation-v2-table-price-bg-yellow' : ''}
                                    `}>
                                    <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                                      {prestigeRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="aps-table-simulation-content-divider-top"></td>
                                  <td className="aps-table-simulation-content-divider-top uk-text-center">
                                    <button className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn  ${isCheckedPremier ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                    disabled={isCheckedPremier}
                                    onClick={() => this.setState({ isCheckedPremier: !isCheckedPremier, isCheckedVitalite: false, isCheckedPrestige: false, isCheckedPlan: true })}>
                                      Selectionner
                                    </button>
                                  </td>
                                  <td className="aps-table-simulation-content-divider-top uk-text-center">
                                    <button className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn  ${isCheckedVitalite ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                    disabled={isCheckedVitalite}
                                    onClick={() => this.setState({ isCheckedPremier: false, isCheckedVitalite: !isCheckedVitalite, isCheckedPrestige: false, isCheckedPlan: true })}>
                                      Selectionner
                                    </button>
                                  </td>
                                  <td className="aps-table-simulation-content-divider-top uk-text-center">
                                    <button className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn  ${isCheckedPrestige ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                    disabled={isCheckedPrestige}
                                    onClick={() => this.setState({ isCheckedPremier: false, isCheckedVitalite: false, isCheckedPrestige: !isCheckedPrestige, isCheckedPlan: true })}>
                                      Selectionner
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="aps-questionnaire-answers-checkbox-first-content aps-simulation-v2-checkbox-mg">
                      <label className="aps-questionnaire-answers-label uk-text-bold" title="Garantie subordonnée aux frais de santé">
                        <input disabled={!isCheckedPlan} checked={isIndividuelAccident} onChange={this.handleIndividuelAccidentCheckboxChange} className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                        Prévoyance Familiale 
                        (capital décès / invalidité)
                      </label>
                    </div>
                    {isIndividuelAccident && (
                      <div className="aps-simulation-v2-checkbox-mg">
                        <div className="aps-section-alerte-green-container-simulation-check aps-simulation-v2-checkbox-mg-individual-acc" data-uk-grid>
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right aps-simulation-v2-checkbox-mg-individual-acc-item">
                            <i className="fa fa-info-circle aps-simulation-v2-picto-infos"></i>
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <p className="aps-section-alerte-green-content-full uk-text-justify aps-simulation-v2-checkbox-mg-bolder">
                            La garantie "Prévoyance Familiale" permet de payer un capital décès aux ayants droit de l'assuré en cas de décès toutes causes ou un capital invalidité à l'assuré lui-même en cas d'invalidité totale et définitive.
                            </p>
                          </div>
                        </div>
                        <div className="aps-simulation-v2-radio-wrap">
                          <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd">
                            Montant du capital décès / invalidité souhaité pour :
                          </div>
                          <div data-uk-grid style={{marginTop: "10px"}}>
                            <div className="uk-width-1-3">
                              <label className="aps-questionnaire-answers-label uk-text-bold">
                                <input checked={isSelectAssuranceLead} onChange={this.handleSelectAssuranceLeadCheckboxChange} className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                                L’assuré principal
                              </label>
                              {(isSelectAssuranceLead && moment().diff(moment(moment(primaryInsuredBirthDate).format('DD-MMM-YYYY'), "DD-MMM-YYYY"), 'years') >= 18) && (
                                <div className="aps-simulation-v2-checkbox-mg aps-simulation-v2-radio-wrap-ml-50">
                                  <select 
                                    className="uk-select aps-section-register-fields aps-simulation-v2-number-input aps-dashboard-table-select-color-green"
                                    name="nbrChildAssuranceLead"
                                    value={nbrChildAssuranceLead}
                                    onChange={event => this.handleOnNbrChildAssuranceLead(event)}
                                  >
                                    {Object.keys(dataNbrChildAssuranceLead).map((value, i) => {
                                      return (
                                        <option value={value} key={i}>{dataNbrChildAssuranceLead[value]}</option>
                                      );
                                    })}
                                  </select>
                                  <div className="aps-simulation-v2-title aps-simulation-v2-radio-wrap aps-simulation-v2-checkbox-mg" style={{fontSize: "12px"}}>
                                    Choisissez une option
                                  </div>
                                </div>
                              )}
                              {isSelectAssuranceLead && moment().diff(moment(moment(primaryInsuredBirthDate).format('DD-MMM-YYYY'), "DD-MMM-YYYY"), 'years') < 18 && (
                                <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd uk-text-bold">
                                  Invalide
                                </div>
                              )}
                              <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd uk-text-bold">
                                La cotisation : {nbrChildTotalPrime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
                              </div>
                            </div>
                            <div className="uk-width-1-3">
                              {dateBirthSpouse && (
                                <div>
                                  <label className="aps-questionnaire-answers-label uk-text-bold">
                                    <input checked={isSelectAssuranceConjoint} onChange={this.handleSelectAssuranceConjointCheckboxChange} className="uk-checkbox aps-questionnaire-answers-checkbox" type="checkbox" />
                                    Le conjoint 
                                  </label>
                                  {(isSelectAssuranceConjoint && moment().diff(moment(moment(dateBirthSpouse).format('DD-MMM-YYYY'), "DD-MMM-YYYY"), 'years') >= 18) && (
                                    <div className="aps-simulation-v2-checkbox-mg aps-simulation-v2-radio-wrap-ml-50">
                                      <select
                                        className="uk-select aps-section-register-fields aps-simulation-v2-number-input aps-dashboard-table-select-color-green"
                                        name="nbrChildConjoint"
                                        value={nbrChildConjoint}
                                        onChange={event => this.handleOnNbrChildConjoint(event)}
                                      >
                                        {Object.keys(dataNbrChildConjoint).map((value, i) => {
                                          return (
                                            <option value={value} key={i}>{dataNbrChildConjoint[value]}</option>
                                          );
                                        })}
                                      </select>
                                      <div className="aps-simulation-v2-title aps-simulation-v2-radio-wrap aps-simulation-v2-checkbox-mg" style={{fontSize: "12px"}}>
                                        Choisissez une option
                                      </div>
                                    </div>
                                  )}
                                  {isSelectAssuranceConjoint && moment().diff(moment(moment(dateBirthSpouse).format('DD-MMM-YYYY'), "DD-MMM-YYYY"), 'years') < 18 && (
                                    <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd uk-text-bold">
                                      Invalide
                                    </div>
                                  )}
                                </div>
                              )} 
                            </div>
                            <div className="uk-width-expand"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                        <button
                          className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn`}
                          onClick={(event) => this.handlePrevPage(event)}
                        >Section précédente</button>

                        <button
                          className={`uk-button aps-btn-green aps-btn-green-dashboard-btn ${invalidFormNextTrois ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                          disabled={invalidFormNextTrois}
                          onClick={(event) => this.handleNextPage(event)}
                        >Section suivante</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentPage === 4 && (
                <div>
                  <div className="aps-simulation-v2-wrap-section" style={{paddingBottom: "30px"}}>
                    <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-date-title-pd-recap uk-text-bold" style={{fontSize: "18px"}}>
                      Récapitulatif
                    </div>
                    <div className="aps-section-alerte-green-container-simulation-check aps-simulation-v2-checkbox-mg-individual-acc-two" style={{marginTop: "10px"}} data-uk-grid>
                      <div className="uk-width-1-6 aps-section-alerte-green-arrow-right aps-simulation-v2-checkbox-mg-individual-acc-item">
                        <div className="aps-simulation-v2-rectangle-recap-green">1</div> 
                      </div>
                      <div className="uk-width-expand aps-section-alerte-green-expand">
                        <div className="aps-simulation-v2-radio-wrap uk-text-bold" style={{color: "#AEC340", paddingTop: "4px", textTransform: "uppercase"}}>
                          L'assurance santé SƆHU
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap">
                          Date d’effet souhaitée : <span className="uk-text-bold">{moment(startSouscriptionDay).format('DD MMMM YYYY')}</span>
                        </div>
                      </div>
                    </div>
                    <div className="aps-section-alerte-green-container-simulation-check aps-simulation-v2-checkbox-mg-individual-acc-two" style={{marginTop: "10px"}} data-uk-grid>
                      <div className="uk-width-1-6 aps-section-alerte-green-arrow-right aps-simulation-v2-checkbox-mg-individual-acc-item">
                        <div className="aps-simulation-v2-rectangle-recap-green">2</div> 
                      </div>
                      <div className="uk-width-expand aps-section-alerte-green-expand">
                        <div className="aps-simulation-v2-radio-wrap uk-text-bold" style={{color: "#AEC340", paddingTop: "4px", textTransform: "uppercase"}}>
                          Les bénéficiaires
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap">
                          Population à assurer : <span className="uk-text-bold">
                            {primaryInsuredBirthDate && <span>assuré principal</span>}
                            {dateBirthSpouse && <span> + conjoint</span>}
                            {
                              nbrChildAssurance > 1
                              ?
                                <span> + {nbrChildAssurance} enfants</span>
                              :
                                <span> + {nbrChildAssurance} enfant</span>
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="aps-section-alerte-green-container-simulation-check aps-simulation-v2-checkbox-mg-individual-acc-two" style={{marginTop: "10px"}} data-uk-grid>
                      <div className="uk-width-1-6 aps-section-alerte-green-arrow-right aps-simulation-v2-checkbox-mg-individual-acc-item">
                        <div className="aps-simulation-v2-rectangle-recap-green">3</div> 
                      </div>
                      <div className="uk-width-expand aps-section-alerte-green-expand">
                        <div className="aps-simulation-v2-radio-wrap uk-text-bold" style={{color: "#AEC340", paddingTop: "4px", textTransform: "uppercase"}}>
                          Le choix de couverture
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap">
                          Les garanties que vous souhaitez :
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap uk-text-bold">
                          FRAIS DE SANTE
                        </div>
                        <div className="aps-simulation-v2-radio-wrap">
                          {isCheckedPremier &&
                            <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                              <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                                <img src={arrow_right_img} alt="arrow-right"/>
                              </div>
                              <div className="uk-width-expand aps-section-alerte-green-expand">
                                <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                  <div className="uk-width-1-6" style={{width: "15%"}}>PREMIER : </div> 
                                  <div className="uk-width-expand" style={{padding: "0"}}>couverture à 60% pour les frais d’hospitalisation et dépenses de médecine courante</div>
                                </div>
                              </div>
                            </div>
                          }
                          {isCheckedVitalite &&
                            <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                              <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                                <img src={arrow_right_img} alt="arrow-right"/>
                              </div>
                              <div className="uk-width-expand aps-section-alerte-green-expand">
                                <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                  <div className="uk-width-1-6" style={{width: "15%"}}>VITALITE : </div> 
                                  <div className="uk-width-expand" style={{padding: "0"}}>couverture à 70% pour les frais d’hospitalisation, dépenses de médecine courante, de maternité, frais dentaires et d'optique</div>
                                </div>
                              </div>
                            </div>
                          }
                          {isCheckedPrestige &&
                            <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                              <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                                <img src={arrow_right_img} alt="arrow-right"/>
                              </div>
                              <div className="uk-width-expand aps-section-alerte-green-expand">
                                <div className="aps-section-alerte-green-content-full uk-text-justify" data-uk-grid>
                                  <div className="uk-width-1-6" style={{width: "16%"}}>PRESTIGE : </div> 
                                  <div className="uk-width-expand" style={{padding: "0"}}>couverture à 80% pour les frais d’hospitalisation, dépenses de médecine courante, de maternité, frais dentaires et d'optique</div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap uk-text-bold">
                          Prévoyance Familiale (capital décès / invalidité)
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap">
                          Assuré principal : <span className="uk-text-bold">{nbrChildAssuranceLead.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA</span>
                        </div>
                        <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-radio-wrap">
                          Conjoint : <span className="uk-text-bold">{nbrChildConjoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA</span>
                        </div>
                      </div>
                    </div>
                    <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                      <button
                        className={`uk-button aps-btn-green aps-btn-green-dashboard-btn`}
                        onClick={(event) => this.setState({currentPage: 1})}
                      >Modifier</button>
                    </div>
                  </div>
                  <div className="aps-dashboard-souscription-switch" style={{height: "30px"}}></div>
                  <div className="aps-simulation-v2-wrap-section" style={{paddingBottom: "10px"}}>
                    <div className="aps-simulation-v2-title aps-simulation-v2-date-title-pd aps-simulation-v2-date-title-pd-recap uk-text-bold" style={{fontSize: "18px"}}>
                      Tarifs personnalisés
                    </div>
                    <div className="aps-simulation-v2-checkbox-mg-individual-acc">
                    <div>
                    <table className="uk-table uk-table-small aps-table-simulation-content aps-js-cal-tab-2" style={{marginTop: "40px", marginBottom: "50px"}}>
                      <tbody>
                        <tr className="aps-simulation-v2-tr-h aps-simulation-v2-tr-h-bg-header">
                          <td className="uk-text-left uk-text-bold">Votre choix de couverture</td>
                          <td className="uk-text-right uk-text-bold">Cotisations annuelles</td>
                        </tr>
                        <tr>
                          <td className="aps-table-simulation-content-divider-top uk-text-left">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">Frais de santé</span> <br />
                              Formule : 
                              {isCheckedPremier && <span> Premier</span>}
                              {isCheckedVitalite && <span> Vitalité</span>}
                              {isCheckedPrestige && <span> Prestige</span>} <br />
                              Territorialité : BENIN avec une extension sur le reste de l’Afrique et l’Europe <br /> pour les séjours temporaires
                            </div>
                          </td>
                          <td className="aps-table-simulation-content-divider-top uk-text-right">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">
                                {isCheckedPremier && <span>{premierRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>} 
                                {isCheckedVitalite && <span>{vitaliteRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA </span>}
                                {isCheckedPrestige && <span>{prestigeRecap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA </span>}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr className="aps-simulation-v2-tr-h">
                          <td className="aps-table-simulation-content-divider-top uk-text-left">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">Réduction famille</span>
                            </div>
                          </td>
                          <td className="aps-table-simulation-content-divider-top uk-text-right">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">
                                {isCheckedPremier && <span>{premierRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>} 
                                {isCheckedVitalite && <span>{vitaliteRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedPrestige && <span>{prestigeRecap.familyDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr className="aps-simulation-v2-tr-h">
                          <td className="aps-table-simulation-content-divider-top uk-text-left">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">Prévoyance Familiale (capital décès / invalidité)</span>
                            </div>
                          </td>
                          <td className="aps-table-simulation-content-divider-top uk-text-right">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">
                                {isCheckedPremier && <span>{premierRecap.boia.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedVitalite && <span>{vitaliteRecap.boia.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedPrestige && <span>{prestigeRecap.boia.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr className="aps-simulation-v2-tr-h">
                          <td className="aps-table-simulation-content-divider-top uk-text-left">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">Accessoires (droit d’adhésion annuel à l’APS : 5 000 FCFA par individu ou 10 000 F CFA par famille + coût de police : 5 000 FCFA )</span>
                            </div>
                          </td>
                          <td className="aps-table-simulation-content-divider-top uk-text-right">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">
                                {isCheckedPremier && <span>{premierRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedVitalite && <span>{vitaliteRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedPrestige && <span>{prestigeRecap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr className="aps-simulation-v2-tr-h-bg-footer">
                          <td className="aps-table-simulation-content-divider-top uk-text-left">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">Cotisation annuelle TTC</span> 
                            </div>
                          </td> 
                          <td className="aps-table-simulation-content-divider-top uk-text-right">
                            <div className="aps-table-simulation-response aps-js-cal-tranche-21-65-first-defaut-value">
                              <span className="uk-text-left uk-text-bold">
                                {isCheckedPremier && <span>{premierRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedVitalite && <span>{vitaliteRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                                {isCheckedPrestige && <span>{prestigeRecap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} FCFA</span>}
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                      <div style={{paddingBottom: "20px"}}>
                        <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                            <img src={arrow_right_img} alt="arrow-right"/>
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <p className="aps-section-alerte-green-content-full uk-text-justify">
                              Les tarifs ci-dessus sont en F CFA et en vigueur à partir du 1er avril 2019. 
                              Ils peuvent subir des majorations en fonction des pathologies
                              déclarées sur le questionnaire médical. La prime définitive sera
                                confirmée au souscripteur après analyse du questionnaire médical par 
                                l’assureur. Le paiement intégral de la police active ensuite les garanties (art. 13 du code CIMA).
                            </p>
                          </div>
                        </div>
                        <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                            <img src={arrow_right_img} alt="arrow-right"/>
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <p className="aps-section-alerte-green-content-full uk-text-justify">
                            Le devis est payable annuellement.
                            </p>
                          </div>
                        </div>
                        <div className="aps-section-alerte-green-container-simulation-none" data-uk-grid>
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                            <img src={calendar_img} alt="calendar" />
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <p className="aps-section-alerte-green-content-full">Délais d'attente :</p>
                          </div>
                        </div>
                        <div className="aps-section-alerte-green-container-simulation-none" data-uk-grid>
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <ul className="uk-list uk-list-bullet aps-section-alerte-green-content-bullet">
                              <li>Pas de délai d'attente en cas d’accident ;</li>
                              <li>01 mois après la souscription pour les soins ordinaires ;</li>
                              <li>06 mois pour la lunetterie et les prothèses dentaires ;</li>
                              <li>06 mois pour les maladies chroniques non rachetées, non déclarées et survenant pour la première fois pendant le contrat ;</li>
                              <li>09 mois pour la maternité.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="aps-section-alerte-green-container-first aps-section-alerte-green-container-first-margin-bottom aps-simulation-v2-container-alert" data-uk-grid>
                        <div className="uk-width-1-6 aps-section-alerte-green-arrow-right uk-flex uk-flex-middle">
                          <img src={fi_alert_img} alt="alert" />
                        </div>
                        <div className="uk-width-expand">
                          <p className="aps-section-alerte-green-content-full uk-text-justify uk-text-center" style={{fontWeight: "bolder"}}>
                          En cas d'atteinte du plafond annuel ou d’un sous plafond par l’assuré et à sa demande, l’assureur
pourra proposer une reconstitution de garanties moyennant prime additionnelle.</p>
                        </div>
                      </div>
                      <div className="aps-section-simulation-logo-section">
                        <p>Ce devis vous est proposé par <br /> votre intermédiaire agréé Atlantique Assurances Bénin : </p>
                        <div>
                          {downloadDevisLogoCourtier.isSuccess
                            ?
                              <div>
                              {(downloadDevisLogoCourtier.logoCourtier.data && downloadDevisLogoCourtier.logoCourtier.data.logo.length === 0)
                                  ?
                                    <div>
                                      <div className="name-courtier-company">{downloadDevisLogoCourtier.logoCourtier.data.companyName}</div>
                                    </div>
                                  :
                                    <div>
                                      <img className="logo-courtier-data-url" src={`${SERVER_URL}/downloads/${downloadDevisLogoCourtier.logoCourtier.data.logo}`} alt="logo-courtier" />
                                    </div>
                                }
                                <div className="tel-courtier-number">Tél : {downloadDevisLogoCourtier.logoCourtier.data.telephone}</div>
                                <div className="tel-courtier-number">E-mail : {downloadDevisLogoCourtier.logoCourtier.data.email}</div>
                              </div>
                            :
                              <div>
                                <img className="logo-courtier-data-url" src={logo_abc} alt="logo-abc" />
                                <div className="tel-courtier-number">Tél : +229 60 11 27 27</div>
                                <div className="tel-courtier-number">E-mail : christian@africabrokersonline.com</div>
                              </div>
                          }
                        </div>
                      </div>
                      {/*Simulation Apply BTN action*/}
                      {/*Btn on Web*/}
                      <div className="uk-section aps-section-simulation-action-btn aps-section-simulation-action-btn-show-web">
                        <div className="uk-child-width-1-2 aps-section-simulation-grid-action" data-uk-grid>
                          <div className="aps-section-simulation-grid-action-column aps-section-simulation-grid-action-column-second">
                            <div className="uk-text-right">
                              <Link className="uk-button aps-btn-simulation-btn-second" to="#aps-simulation-receive-mail-modal-center" data-uk-toggle="{target: #aps-simulation-receive-mail-modal-center}">Recevoir le devis par mail</Link>
                            </div>
                          </div>
                          <div className="aps-section-simulation-grid-action-column aps-section-simulation-grid-action-column-third">
                            <div className="uk-text-left">
                              {getUrlParameter('fromIntermediaire')
                                ?
                                <Link className="uk-button aps-btn-simulation-btn-third" target="_blank" to="https://app.aps-benin.com/connexion-intermediaires">Souscrire</Link>
                                :
                                <Link className="uk-button aps-btn-simulation-btn-third" to="#aps-simulation-login-modal-center" data-uk-toggle="{target: #aps-simulation-login-modal-center}">Souscrire</Link>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*Btn on mobile*/}
                      <div style={{display: "none"}} className="uk-section aps-section-simulation-action-btn aps-section-simulation-action-btn-show-mobile">
                      <div className="uk-text-center aps-section-simulation-action-btn-first">
                        <Link className="uk-button aps-btn-simulation-btn-second" to="#aps-simulation-receive-mail-modal-center" data-uk-toggle="{target: #aps-simulation-receive-mail-modal-center}">Recevoir le devis par mail</Link>
                      </div>
                      <div className="uk-text-center">
                        {getUrlParameter('fromIntermediaire')
                          ?
                          <Link className="uk-button aps-btn-simulation-btn-third" target="_blank" to="https://app.aps-benin.com/connexion-intermediaires">Souscrire</Link>
                          :
                          <Link className="uk-button aps-btn-simulation-btn-third" to="#aps-simulation-login-modal-center" data-uk-toggle="{target: #aps-simulation-login-modal-center}">Souscrire</Link>
                        }
                      </div>
                    </div>
                    </div>
                  </div>
                  <div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                        <button
                          className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn`}
                          onClick={(event) => this.handlePrevPage(event)}
                        >Section précédente</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        <Footer/> 
        {/*Simulation Modal Login User*/}
        <div id="aps-simulation-login-modal-center" className="uk-flex-top" data-uk-modal="bg-close: false; esc-close: false">
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical aps-modal-dialog">
            <button className="uk-modal-close-default uk-icon aps-modal-close uk-close" type="button" data-uk-close="">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" ratio="1"><line fill="none" stroke="#000" strokeWidth="1.1" x1="1"
              y1="1" x2="13" y2="13"></line><line fill="none" stroke="#000" strokeWidth="1.1" x1="13" y1="1" x2="1" y2="13"></line></svg>
            </button>
            <div className="uk-section aps-section-parrain">
              <h1 className="uk-text-center aps-section-parrain-title-modal">
                Vous devez vous connecter ou créer un compte pour continuer
              </h1>
              <div className="uk-text-center aps-section-parrain-content-modal">
                Le compte est sans engagement et vous permet de sauvergarder vos informations de souscription pour y revenir quand vous le souhaitez
              </div>
              <div className="aps-section-contacter-modal-show-web">
                <div className="uk-child-width-1-4 aps-section-contacter-column" data-uk-grid>
                  <div></div>
                  <div>
                    <div className="uk-text-right aps-section-contacter-action-btn">
                      <Link className="uk-button aps-btn-simple-silver-contacter" onClick={() => this.checkCloseCanvas()} to="/connexion">Connexion</Link>
                    </div>
                  </div>
                  <div className="aps-section-contacter-action-content">
                    <div className="uk-text-left aps-section-contacter-action-btn">
                      <Link className="uk-button aps-section-contacter-action-btn-full" onClick={() => this.checkCloseCanvas()} to="/inscription">Créer un compte</Link>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
              <div style={{display: "none"}} className="aps-section-contacter-modal-show-mobile">
                <div className="uk-child-width-1-2 aps-section-contacter-column" data-uk-grid>
                  <div className="aps-section-contacter-action-btn-first-col">
                    <div className="uk-text-right aps-section-contacter-action-btn">
                      <Link className="uk-button aps-btn-simple-silver-contacter" onClick={() => this.checkCloseCanvas()} to="/connexion">Connexion</Link>
                    </div>
                  </div>
                  <div className="aps-section-contacter-action-btn-second-col">
                    <div className="uk-text-left aps-section-contacter-action-btn">
                      <Link className="uk-button aps-section-contacter-action-btn-full" onClick={() => this.checkCloseCanvas()} to="inscription">Créer un compte</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Simulation Modal Receive Mail*/}
        <div id="aps-simulation-receive-mail-modal-center" className="uk-flex-top" data-uk-modal="bg-close: false; esc-close: false">
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical aps-modal-dialog">
            <button className="uk-modal-close-default uk-icon aps-modal-close uk-close"
              type="button"
              data-uk-close=""
              onClick={() => this.resetAllFields()}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" ratio="1"><line fill="none" stroke="#000" strokeWidth="1.1" x1="1"
              y1="1" x2="13" y2="13"></line><line fill="none" stroke="#000" strokeWidth="1.1" x1="13" y1="1" x2="1" y2="13"></line></svg>
            </button>
            <div className="uk-section aps-section-parrain">
              {sendMailToSouscripteur.isError && notificationSendMailToSimulationError &&
                <div>
                  { this.NotificationSendMailToSimulationError() }
                </div>
              }
              {notificationConversionDevisError &&
                <div>
                  { this.NotificationConversionDevisError() }
                </div>
              }
              <div className="aps-section-contacter-modal-show-web">
                {(isLoadingConvert)
                  ?
                    <div className="aps-spinner-component-loading">
                      <div className="uk-spinner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                        </svg>
                      </div>
                      <div className="aps-section-register-desc">chargement en cours</div>
                    </div>
                  :
                    <div>
                      {notificationSuccessConversionPDF
                        ?
                          <div>
                            <h1 className="uk-text-center aps-section-parrain-title-modal">
                              Votre devis a bien été généré
                            </h1>
                            <div className="uk-text-center aps-section-parrain-content-modal">
                              Un mail contenant le lien de téléchargement du devis en PDF vous sera envoyé dans quelques instants.
                            </div>
                          </div>
                        :
                          <div>
                            <h1 className="uk-text-center aps-section-parrain-title-modal">
                              Recevoir le devis par mail
                            </h1>
                            <form onSubmit={this.handleSubmit}>
                              <div className="aps-section-contacter-column">
                                <div className="aps-section-resgister-souscripteur-form">
                                {/*Civility*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                    <p className="uk-text-left aps-section-contacter-fields-name">Civilité</p>
                                    <div className="uk-inline aps-section-register-fields-full">
                                      <select
                                        className="uk-select aps-section-register-fields"
                                        name="civility"
                                      >
                                        <option value="monsieur">Monsieur</option>
                                        <option value="madame">Madame</option>
                                      </select>
                                    </div>
                                  </div>
                                {/*Nom*/}
                                  <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                    <p className="uk-text-left aps-section-contacter-fields-name">Nom</p>
                                    <div className="uk-inline aps-section-register-fields-full">
                                      <input
                                        type="text"
                                        className="uk-input aps-section-register-fields"
                                        placeholder="Votre nom"
                                        name="firstname"
                                      />
                                    </div>
                                  </div>
                                {/*Prenom*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">Prénom</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre prénom"
                                      name="lastname"
                                    />
                                  </div>
                                </div>
                                {/*Email*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">E-mail</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre email"
                                      name="email"
                                    />
                                  </div>
                                </div>
                                {/*Email facultatif*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">E-mail facultatif</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre email facultatif"
                                      name="emailFacultatif"
                                    />
                                  </div>
                                  <p className="uk-text-left aps-section-contacter-fields-name" style={{fontWeight: "bold", paddingTop: "6px"}}>
                                Vous pouvez mettre plusieurs mails en les séparant par des virgules (,) </p>
                                </div>
                                {/**BTN apply*/}
                                <div className="uk-text-center">
                                  <button className="uk-button aps-btn-green aps-btn-green-dashboard-btn">Envoyer</button>
                                </div>
                                </div>
                              </div>
                            </form>
                          </div>
                      }
                    </div>
                }
              </div>
              <div style={{display: "none"}} className="aps-section-contacter-modal-show-mobile">
                {(isLoadingConvert)
                  ?
                    <div className="aps-spinner-component-loading">
                      <div className="uk-spinner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                        </svg>
                      </div>
                      <div className="aps-section-register-desc">chargement en cours</div>
                    </div>
                  :
                    <div>
                      {notificationSuccessConversionPDF
                        ?
                          <div>
                            <h1 className="uk-text-center aps-section-parrain-title-modal">
                              Votre devis a bien été généré
                            </h1>
                            <div className="uk-text-center aps-section-parrain-content-modal">
                              Un mail contenant le lien de téléchargement du devis en PDF vous sera envoyé dans quelques instants.
                            </div>
                          </div>
                        :
                          <div>
                            <h1 className="uk-text-center aps-section-parrain-title-modal">
                              Recevoir le devis par mail
                            </h1>
                            <form onSubmit={this.handleSubmit}>
                              <div className="aps-section-contacter-column">
                                <div className="aps-section-resgister-souscripteur-form">
                                {/*Civility*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                    <p className="uk-text-left aps-section-contacter-fields-name">Civilité</p>
                                    <div className="uk-inline aps-section-register-fields-full">
                                      <select
                                        className="uk-select aps-section-register-fields"
                                        name="civility"
                                      >
                                        <option value="monsieur">Monsieur</option>
                                        <option value="madame">Madame</option>
                                      </select>
                                    </div>
                                  </div>
                                {/*Nom*/}
                                  <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                    <p className="uk-text-left aps-section-contacter-fields-name">Nom</p>
                                    <div className="uk-inline aps-section-register-fields-full">
                                      <input
                                        type="text"
                                        className="uk-input aps-section-register-fields"
                                        placeholder="Votre nom"
                                        name="firstname"
                                      />
                                    </div>
                                  </div>
                                {/*Prenom*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">Prénom</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre prénom"
                                      name="lastname"
                                    />
                                  </div>
                                </div>
                                {/*Email*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">E-mail</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre email"
                                      name="email"
                                    />
                                  </div>
                                </div>
                                {/*E-mail facultatif*/}
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">E-mail facultatif</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <input
                                      type="text"
                                      className="uk-input aps-section-register-fields"
                                      placeholder="Votre email"
                                      name="emailFacultatif"
                                    />
                                  </div>
                                  <p className="uk-text-left aps-section-contacter-fields-name" style={{fontWeight: "bold", paddingTop: "6px"}}>
                                Vous pouvez mettre plusieurs mails en les séparant par des virgules (,) </p>
                                </div>
                                {/**BTN apply*/}
                                <div className="uk-text-center">
                                  <button className="uk-button aps-btn-green aps-btn-green-dashboard-btn">Envoyer</button>
                                </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        }
                    </div>
                  }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, sendMailToSouscripteur, downloadDevisLogoCourtier }) => {
  return {
    reauthenticateMembers,
    sendMailToSouscripteur,
    downloadDevisLogoCourtier,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    userSendMailToSimulation: (emailData) => dispatch(fetchSendMailSouscripteurAction(emailData)),
    userDownloadDevisLogoCourtier: (codeApporteur) => dispatch(fetchDownloadDevisLogoCourtierAction(codeApporteur)),
  }
}
function isOlder(birthday, limitAge) {
  let age = moment().diff(birthday, 'years')
  return age > limitAge
}
function isYounger(birthday, limitAge) {
  let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')
  return age < limitAge
}
function getUrlParameter  (name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  let results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
export default connect(mapStateToProps, mapDispatchToProps)(Simulation)



// WEBPACK FOOTER //
// ./src/containers/Simulation/index.js